<rt-box>
  <div class="container">
    <div margin-bottom-small>
      <rt-heading variant="heading large block">
        {{ 'app.offer_assignments.recruiters_short' | translate }}
      </rt-heading>
      <rt-heading variant="subheading normal">
        {{ 'app.requisitions.team_members.subheading' | translate }}&nbsp;
        <a rtHelpArticle="creatingRequisition">
          {{ 'app.common.learn_more' | translate }}
        </a>
      </rt-heading>
    </div>

    @if (assignments) {
      <div>
        @for (assignment of assignmentsWithAdmin; track trackById($index, assignment)) {
          <rt-team-members-item
            [admin]="assignment.admin"
            [isDisabled]="isAdminDisabled(assignment)"
            [removable]="canEditMembers"
            [adminInRemove]="adminInRemove"
            [removeTooltipText]="
              isAdminDisabled(assignment) ? texts.cantRemoveTooltip : texts.removeMemberTooltip
            "
            [headingSlotTemplate]="headingSlotTpl"
            (removeFollower)="removeAssignment($event)"
          />
          <ng-template #headingSlotTpl>
            @for (badgeText of getBadgesTextList(assignment); track trackByIndex($index)) {
              <rt-badge
                color="secondary"
                [text]="badgeText"
                [rtTooltip]="'app.requisitions.team_members.badges_tooltip' | translate"
                margin-left-small-x
              />
            }
          </ng-template>
        }

        @for (roleWithAdmins of rolesWithAdmins; track trackById($index, roleWithAdmins)) {
          <rt-team-members-item
            [roleWithAdmins]="roleWithAdmins"
            [removable]="false"
            [collapsable]="true"
            [roleDescription]="
              'app.requisitions.team_members.can_access_description'
                | translate: { count: roleWithAdmins.count }
            "
          />
        }
      </div>
    }

    @if (invitations.length && canEditMembers) {
      <rt-heading variant="heading" margin-top-large margin-bottom-small-xx>
        {{ 'app.memberships.invitations_title' | translate }}
      </rt-heading>
      <div margin-bottom>{{ 'app.memberships.invitations_info' | translate }}</div>

      @for (invitation of invitations; track trackById($index, invitation)) {
        <rt-invitation-item
          [invitation]="invitation"
          (resendInvitation)="resendInvitation($event)"
          (deleteClick)="deleteInvitation($event)"
          margin-bottom
        />
      }
    }

    @if (canEditMembers) {
      <div class="actions">
        <rt-button (click)="openTeamMemberDialog()" variant="outline">
          <rt-icon name="add" />
          <span>{{ 'app.offer_assignments.add_team_member' | translate }}</span>
        </rt-button>
      </div>
    }
  </div>
</rt-box>
